import { render, staticRenderFns } from "./FrontConfigAccesses.vue?vue&type=template&id=0d525d44&scoped=true&"
import script from "./FrontConfigAccesses.vue?vue&type=script&lang=js&"
export * from "./FrontConfigAccesses.vue?vue&type=script&lang=js&"
import style0 from "./FrontConfigAccesses.vue?vue&type=style&index=0&id=0d525d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d525d44",
  null
  
)

export default component.exports